import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Navigation } from 'app/core/navigation/navigation.types';
import { getHorizontalNavigation } from './nav-data';
import { UserService } from '../user/user.service';
import { OAuthService } from '../auth/oauth.service';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

  /**
   * Constructor
   */
  constructor(
    userService: UserService,
    private toastr: ToastrService,
    private translocoService: TranslocoService,
  ) {
    userService.getCurrentUser().then(() => {
      const horizontalNavigation = getHorizontalNavigation(() => {
        this.toastr.warning(this.translocoService.translate('GisUpgradeAccountTooltip'));
      });
      this._navigation.next({
        compact: horizontalNavigation,
        default: horizontalNavigation,
        futuristic: horizontalNavigation,
        horizontal: horizontalNavigation,
      });
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for navigation
   */
  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this._navigation.asObservable();
    /* return this._httpClient.get<Navigation>('api/common/navigation').pipe(
           tap((navigation) => {
               this._navigation.next(navigation);
           })
       );*/
  }
}
